import script from "./init.vue?vue&type=script&setup=true&lang=js"
export * from "./init.vue?vue&type=script&setup=true&lang=js"

import "./init.vue?vue&type=style&index=0&id=4c42e989&lang=scss&scoped=true"

import exportComponent from "D:\\yunchi\\yc\\yc-vue-source\\new-energy\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c42e989"]])

export default __exports__